import React from 'react';
import '../template-file-css/document-file-template.css';



export const MRRC_MemberChoiceForm = ({
    itemsRef,
    showErrorFor,
    
}) => {

    return (
        <form id='MRRC_MemberChoiceForm' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'><h2>MEMBER'S TOTAL CHOICE</h2></p>

<table>
    <tr><td className='w-375'><span className='eleHeader'>TELEPHONE:</span></td>
        <td className='w-375'><span className='eleHeader'>FAX:</span></td>
    </tr>
    <tr>
        <td className='w-375'> <input type='text' id='txtTelephone_1' name='txtTelephone_1' defaultValue={3188281455} className='add-only' /></td>
        <td className='w-375'> <input type='text' id='txtFax_2' name='txtFax_2' defaultValue={3188281626} className='add-only' /></td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>THE PROVIDER I CHOOSE IS:</span>
            <span className='small'>Mild Rehabilitation & Resource Center</span>
            <tr>
                <td className='w-750'> <input type='text' id='txtTheProviderIChoose' name='txtTheProviderIChoose' className='add-only' />

                </td>
            </tr>

        </td>
    </tr>
</table>

<p className='w-750'>By signing below , I acknowledge that I freely choose to receive services from the above provider and I also acknowledge my responsibility to notify my previous provider in order to coordinate care.</p>

<table>
    <tr>
        <td className='signature w-375'>&nbsp; </td>
        <td className='signature w-375'>&nbsp; </td>
    </tr>
    <tr>
        <td className='small w-375'>Member Name</td>
        <td className='small w-375'>Member Date of Birth</td>
    </tr>
    <tr>
        <td className='signature w-375'>&nbsp; </td>
        <td className='signature w-375'>&nbsp; </td>
    </tr>
    <tr>
        <td className='small w-375'>{`Member/Legal Guardian Signature`}</td>
        <td className='small w-375'>{`Today's Date`}</td>
    </tr>
</table>

<p className='w-750'>A total choice form is required prior to service authorizations. The form requires a member signature, date, identified provider and provider phone number. This provider assumes responsibility of coordinating care with the prior provider on record.</p>

<table>
    <tr>
        <td className='signature w-750'>&nbsp;</td>
    </tr>
    <tr>
        <td className='small w-750'>Provider Representative Signature</td>
    </tr>
</table>

<p className='w-750'><h2>Healthy Louisiana Mental Health Rehabilitation Member Choice Form</h2>
<b>Member Information:</b>I am requesting services from a mental health rehabilitation (MHR) provider. I understand that I have the right to choose an agency to provide services to me or my child. I understand that I may only receive MHR services from one provider unless my health plan makes an exception. I may change provider if I am not satisfied with the services. <br />
If assistance is needed with finding an MHR Provider, review the list of providers located at your health plan's website below or call your plan for assistance.<br />
<ol>
    <li className='w-700'>Aetna:<a href='https://www.aetnabetterhealth.com/louisiana/find-provider'>https://www.aetnabetterhealth.com/louisiana/find-provider</a>or call 1-855-242-0802 Hearing impaired
        TTY/TDD 711</li>
    <li className='w-700'>Amerihealth Caritas Louisiana:<a href='http://www.amerihealthcaritasla.com/member/eng/tools/find-provider.aspx'>http://www.amerihealthcaritasla.com/member/eng/tools/find-provider.aspx</a>or call
        1-888-756-0004; TTY 1-866-428-7588</li>
    <li className='w-700'>Healthy Blue:<a href='https://www.myhealthybluela.com/la/care/find-a-doctor.html'>https://www.myhealthybluela.com/la/care/find-a-doctor.html</a>or call 1-844-227-8350 (TTY 711)</li>
    <li className='w-700'>Louisiana Healthcare Connections:<a href='https://providersearch.louisianahealthconnect.com/'> https://providersearch.louisianahealthconnect.com/</a>or call 1-866-595- 8133
        (Hearing Loss: 711)</li>
    <li className='w-700'>United Healthcare Community:<a href='http://www.uhccommunityplan.com/la/medicaid/healthy-louisiana.html'>http://www.uhccommunityplan.com/la/medicaid/healthy-louisiana.html</a>or call
        1-866-675-1607 TTY: 1-877-4285-4514</li>
</ol>

</p>
 <p className='w-750'>The provider that I have freely selected to deliver MHR services to me or my child is :
    </p>
        
    <table>

    <tr><td className='w-375'><span className='eleHeader'>Provider Name:</span></td>
        <td className='w-375'><span className='eleHeader'>Provider Phone Number:</span></td>
    </tr>
    <tr>
        <td className='w-375'> <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only' /></td>
        <td className='w-375'> <input type='text' id='txtProviderPhone_2' name='txtProviderPhone_2' className='add-only' /></td>
    </tr>
    <tr><td className='w-375'><span className='eleHeader'>Provider Contact Name:</span></td>
        <td className='w-375'><span className='eleHeader'>Provider Address:</span></td>
    </tr>
    <tr>
        <td className='w-375'> <input type='text' id='txtProviderContact_1' name='txtProviderContact_1' className='add-only' /></td>
        <td className='w-375'> <input type='text' id='txtProviderAddress_2' name='txtProviderAddress_2' className='add-only' /></td>
    </tr>

</table>

<p className='w-750'>By signing the form below, I understand that I have chosen to receive services from this MHR provider and I acknowledge that it is my responsibility to notify my previous provider so they can coordinate my care with my new provider. I understand that I am free to choose any MHR provider in my health plan's network.</p>

<table>
    <tr>
        <td className='signature w-375'>&nbsp;</td>
        <td className='signature w-375'>&nbsp;</td>
    </tr>
    <tr>
        <td className='small w-375'>{`Member/Legal Guardina Signature`}</td>
        <td className='small w-375'>Date</td>
    </tr>
    <tr>
        <td className='signature w-750'>&nbsp;</td>
        </tr>
        <tr>
        <td className='small w-375'>{`Printed Legal Guardian Name (if applicable)`}</td>
        </tr>


</table>

<p className='w-750'><b>Provider Information:</b>A Member choice form is required proir to receiving any mental health rehabilitation services. This form requires member/legal guardian signature, date , identified provider with telephone and contact name. The provider is responsible for coordinating the transition of care with the member's previous provider prior to starting services.</p>

<table>
<tr>
        <td className='signature w-375'>&nbsp;</td>
        <td className='signature w-375'>&nbsp;</td>
    </tr>
    <tr>
        <td className='small w-375'>Provider Signature</td>
        <td className='small w-375'>Date</td>
    </tr>
    
</table>



               



            </div>
        </form>

    )
}  
